import React from 'react';
import { useTranslation } from 'react-i18next';

const HeadingDatoContacto = () => {
  const { t } = useTranslation();

  return (
    <h2 id="personales" className="bloque-datos__title u-text-brand">
      <span className="divider__square brand-color" />
      <span className="u-margin-right">
        {t('datos.personaldata.datos-de-contacto')}
      </span>
    </h2>
  );
};

export default HeadingDatoContacto;
